<template>
  <v-layout wrap row>
    <v-flex xs10>
      <v-select
        v-model="contentType"
        :items="contentTypes"
        label="Content type"
        item-text="label"
        item-value="value"
      ></v-select>
    </v-flex>
    <v-flex xs2>
      <v-btn
        icon
        fab
        @click="
          $emit('add', contentType);
          contentType = null;
        "
        :disabled="loading || !contentType"
        color="primary"
      >
        <v-icon v-text="fa('plus')"></v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import { ContentType } from "../../config/constants";
export default {
  props: {
    loading: Boolean
  },
  data: () => ({
    contentType: null
  }),
  computed: {
    contentTypes: () =>
      ContentType.map(contentType => ({
        label: contentType.label,
        value: {
          type: contentType.value,
          data: contentType.data
        }
      }))
  }
};
</script>
